import React from 'react';
import {ActivityIndicator, Modal} from 'react-native';
import {useTheme} from 'styled-components/native';
import {Container, LoadingContainer} from './styles';

interface LoadingProps {
  visible?: boolean;
}

/**
 * @deprecated Usa o `<Modal>` nativo do RN, que causa tela preta no iOS quando
 * sobreposto a outro Modal. Em telas com outros modais (ex.: checkout) use o
 * `SpinnerLoading` (`shared/Payments/SpinnerLoading`), que renderiza via
 * portal (OverlayModal). Mantido aqui para as demais telas que ainda o usam.
 */
export function Loading({visible = true}: LoadingProps) {
  const theme = useTheme();

  return (
    <Modal
      visible={visible}
      transparent
      statusBarTranslucent

      onRequestClose={() => {}}
    >
      <Container pointerEvents="auto">
        <LoadingContainer>
          <ActivityIndicator color={theme.colors.loading} />
        </LoadingContainer>
      </Container>
    </Modal>
  );
}
